export default "__VITE_ASSET__D4GZ7oSE__"